//============ wy.core.services.examine.ExaminePaper =============
import {DataPacket} from '@/base/DataPacket';
import {NorDataList} from '@/base/NorDataList';  


export class ExamineQuestion extends DataPacket {
    constructor(opts= {}){
        super();
        this.CaculatePolicyName = opts.CaculatePolicyName || '';
        this.Code = opts.Code || '';
        this.Description = opts.Description || '';
        this.KeyId = opts.KeyId || '';
        this.ChildList = new ExamineQuestionList(opts.ChildList)  || new ExamineQuestionList();
        this.Title = opts.Title || '';
        this.PaperKeyId = opts.PaperKeyId || '';
        this.Score = opts.Score || null;
        this.ParentKeyId = opts.ParentKeyId || '';
        this.AnswerContent = opts.AnswerContent || '';
        this.QuestionTypeDefine = opts.QuestionTypeDefine || '';
        this.QuestionType = opts.QuestionType || '';
        this.Changed = opts.Changed || false;
    }
}

export class ExaminePaper extends DataPacket {
    constructor(opts= {}){
        super();
        this.QuestionsList = new ExamineQuestionList(opts.QuestionsList)  || new ExamineQuestionList();
        this.Description = opts.Description || '';
        this.KeyId = opts.KeyId || '';
        this.Oper = opts.Oper || '';
        this.Title = opts.Title || '';
        this.Type = opts.Type || null;
        this.SpecialType = opts.SpecialType || null;
    }
}


//============ wy.core.services.examine.ExamineQuestionList =============

export class ExamineQuestionList extends NorDataList {
    constructor(list={}) {
        super();
        if(list&&list._Items){
            for(const item of list._Items){
                this.append(new ExamineQuestion(item));
            }
        }
    }
}

//============ wy.core.services.examine.FullTextDefine =============

export class FullTextDefine extends DataPacket {
    constructor(opts= {}){
        super();
        this.TextType = opts.TextType || null;
        this.MaxLength = opts.MaxLength || null;
    }
}